import { StarMinusOutlineIcon } from './StarMinusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 24A0E7F1-32AA-4B4B-B0BC-93AD9F7E2F8A
 * name star-minus-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-minus-outline.svg
 * tags
 * - Shape 
 */
export const FavoriteMinusOutlineIcon = StarMinusOutlineIcon;
export default FavoriteMinusOutlineIcon